import { Link } from "react-router-dom";
import { LangSwitch } from "@/components/LangSwitch";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

import { tr } from "@/lib/i18n";
const BG = "https://images.pexels.com/photos/35691079/pexels-photo-35691079.jpeg?auto=compress&cs=tinysrgb&w=1400";

export const AuthField = ({ id, label, ...p }) => (
  <div className="space-y-1.5">
    <Label htmlFor={id} className="text-xs font-tech uppercase tracking-wider text-slate-500">{label}</Label>
    <Input id={id} className="h-11" {...p} />
  </div>
);

export const AuthError = ({ children }) => children ? (
  <div className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-3 py-2" data-testid="auth-error">{children}</div>
) : null;

export const AuthShell = ({ title, subtitle, children, onSubmit, testid = "auth-form" }) => (
  <div className="min-h-screen flex bg-slate-50">
    <aside className="hidden lg:flex relative w-[46%] bg-slate-900 overflow-hidden">
      <img src={BG} alt={tr("Impianto fotovoltaico su tetto")} className="absolute inset-0 w-full h-full object-cover opacity-60" />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-900/40 to-transparent" />
      <div className="relative mt-auto p-12 text-white max-w-lg">
        <img src="/synvora-logo-light.svg" alt={tr("Synvora Design")} className="h-10 w-auto mb-6" data-testid="auth-aside-logo" />
        <h2 className="font-display text-3xl font-semibold leading-tight">{tr("Progettazione strutturale FV, dal tetto alla distinta.")}</h2>
        <p className="text-slate-300 mt-3 text-sm">{tr("Carichi SIA 261, posa dei moduli, verifiche e report in un unico spazio di lavoro per te e la tua azienda.")}</p>
      </div>
    </aside>
    <main className="relative flex-1 grid place-items-center px-6 py-12">
      <div className="absolute top-5 right-6"><LangSwitch /></div>
      <form onSubmit={onSubmit} className="w-full max-w-sm space-y-6 sr-rise" data-testid={testid}>
        <Link to="/accesso" className="flex items-center gap-2.5 w-fit">
          <img src="/synvora-logo-dark.svg" alt="Synvora" className="h-9 w-auto" data-testid="auth-logo" />
          <span className="font-tech text-[11px] uppercase tracking-[0.25em] text-[#0F52BA] pt-1.5">{tr("Design")}</span>
        </Link>
        <div>
          <h1 className="text-4xl font-display font-bold tracking-tight text-slate-900">{title}</h1>
          {subtitle && <p className="text-slate-500 text-sm mt-2">{subtitle}</p>}
        </div>
        {children}
      </form>
    </main>
  </div>
);
